<template>
  <div class="refund-list">
    <div id="TopTabs" class="content">
      <SearchNav />
      <el-tabs v-model="activeStatus" @tab-click="changeStatus">
        <el-tab-pane
            v-for="tab in tabs"
            :label="tab.title"
            :name="String(tab.name)"
            :key="tab.name"
        ></el-tab-pane>
      </el-tabs>
      <div class="filter_search">
        <el-input :clearable='true' v-model="searchParams.querySn" size="mini" class="filter-input" placeholder="请输入订单编号/退款编号"/>
        <el-input :clearable='true' v-model="searchParams.itemName" size="mini" class="filter-input" placeholder="请输入商品名称"/>
        <el-date-picker
            :clearable='true'
            size="mini"
            class="m_r"
            v-model="searchParams.applyTimeBeginAndEnd"
            type="datetimerange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
        ></el-date-picker>
        <span @click="onSearch" class="search__btn center">
          搜索
        </span>
      </div>

<!--      <div class="refund-title">-->
<!--        <div class="title-goods-detail">商品详情</div>-->
<!--        <div class="title-apply-refund-count">申请退款总额</div>-->
<!--        <div class="title-apply-refund-reason">退款原因</div>-->
<!--        <div class="title-apply-refund-way">退款方式</div>-->
<!--        <div class="title-apply-refund-status">退款状态</div>-->
<!--        <div class="title-apply-refund-op">操作</div>-->
<!--      </div>-->

      <div>
        <template v-if="refundList.length">
          <div class="page-table">
            <refundsList :List="refundList"></refundsList>
            <div class="pagination">
              <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="searchParams.pageNo"
                  :page-sizes="[10, 20, 50]"
                  :page-size="searchParams.pageSize"
                  layout="total,sizes, prev, pager, next,jumper"
                  :total="totalRecord"
                  background
              ></el-pagination>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="list-empty">
            <img :src="require('@/assets/img/shop-empty.png')" alt="" />
            <span>暂无数据</span>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import SearchNav from '@/components/SearchNav'
import PublicDialog from '@/pages/Order/OrderDetail/components/PublicDialog'
import Contract from '@/components/contract'
import { mapGetters } from 'vuex'
import * as api from '@/services'
import dayjs from 'dayjs'
import VueScrollTo from 'vue-scrollto'
import refundsList from '@/pages/refund/list/components/refundsList'
import { fen2yuanAddZeroes } from '@/utils/calculate'

const scrollOptions = {
  container: '.layout-component',
  duration: 200,
  lazy: false,
  easing: 'ease',
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
};

const REFUND_STATUS = {
  waitAudit: 1,
  waitSend: 2,
  waitConfirm: 3,
  waitRefund: 4,
  refund: 5,
  refundConfirm: 6,
  refundClose: 9,
  refundSuccess: 7,
  refundCharge: 8
}

const tabNames = {
  all: '全部',
  waitAudit: '待商家审核',
  waitSend: '待买家寄回商品',
  waitConfirm: '待商家确认收货',
  waitRefund: '待商家退款',
  refund: '退款中',
  refundConfirm: '待买家确认收款',
  refundClose: '退款关闭',
  refundSuccess: '退款成功',
  refundCharge: '退货挂账',
}

export default {
  components: { PublicDialog, SearchNav, Contract, refundsList },
  computed: {
    ...mapGetters({
      groupChat: 'imChatService/getPcGroupChat',
      groupList: 'imChatService/getPcGroupList'
    }),
    querySn() {
      return this.$route.query.orderSn;
    },
  },
  data() {
    return {
      activeStatus: '', // 选中的tab
      tabs: [
        {
          title: '全部',
          name: 'all'
        },
        {
          title: '待商家审核',
          name: 'waitAudit'
        },
        {
          title: '待买家寄回商品',
          name: 'waitSend'
        },
        {
          title: '待商家确认收货',
          name: 'waitConfirm'
        },
        {
          title: '待商家退款',
          name: 'waitRefund'
        },
        {
          title: '退款中',
          name: 'refund'
        },
        {
          title: '待买家确认收款',
          name: 'refundConfirm'
        },
        {
          title: '退款关闭',
          name: 'refundClose'
        },
        {
          title: '退款成功',
          name: 'refundSuccess'
        },
        {
          title: '退货挂账',
          name: 'refundCharge'
        },
      ],
      // 列表相关
      refundList: [],
      error: false,
      finished: false,
      loading: false,
      totalRecord: 0,
      // 搜索项
      searchParams: {
        pageNo: 1,
        pageSize: 10,
        querySn: '', // 订单编号/退货退款单编号
        itemName: '', // 商品名称
        applyTimeBeginAndEnd: null, // 申请开始、结束时间
      }
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      if (!this.searchParams.querySn && this.querySn) {
        this.searchParams.querySn = this.querySn
      }
      await this.getRefundList()
      await this.getTabNumber()
      this.activeStatus = 'all'
    },
    changeStatus() {
      this.searchParams = {
        pageNo: 1,
        pageSize: 10,
        querySn: '', // 订单编号/退货退款单编号
        itemName: '', // 商品名称
        applyTimeBeginAndEnd: null, // 申请开始、结束时间
      }
      this.getRefundList()
      this.getTabNumber()
    },
    onSearch() {
      this.searchParams = {
        ...this.searchParams,
        pageNo: 1,
        pageSize: 10
      }
      this.getRefundList()
    },
    // 获取tab数量
    async getTabNumber() {
      const res = await api.refund.queryRefundCount({ ...this.searchParams })
      this.tabs = this.tabs.map(tab => {
        const { name } = tab
        const newTitle = tabNames[name] + '(' + (res[name + 'Num'] || 0) + ')'
        return {
          title: newTitle,
          name
        }
      })
    },

    handleSizeChange(size) {
      this.searchParams.pageSize = size
      this.searchParams.pageNo = 1
      this.getRefundList()
    },
    handleCurrentChange(page) {
      this.searchParams.pageNo = page
      this.getRefundList()
    },

    // 获取退款单列表
    async getRefundList(status = this.activeStatus) {
      this.error = false;
      this.finished = false;
      this.loading = true;
      try {
        const params = {
          ...this.searchParams,
          refundShowStatus: REFUND_STATUS[status],
        }
        if (this.searchParams.applyTimeBeginAndEnd) {
          params.applyTimeBegin = this.searchParams.applyTimeBeginAndEnd[0]
          params.applyTimeEnd = this.searchParams.applyTimeBeginAndEnd[1]
        }
        const res = await api.refund.queryRefundList(params)
        const totalPage = Math.floor(res.totalRecord / this.searchParams.pageSize) // 总页数
        this.totalRecord = res.totalRecord
        this.loading = false
        this.refundList = res.list.map(item => ({
          ...item,
          itemInfos: item.itemInfos.map(it => ({
            ...it,
            realPriceYuan: fen2yuanAddZeroes(it.realPrice),
            unitPriceYuan: fen2yuanAddZeroes(it.unitPrice),
            refundPayAmountYuan: fen2yuanAddZeroes(it.refundPayAmount),
          })),
          refundSuccessAmountYuan: fen2yuanAddZeroes(item.refundSuccessAmount),
          refundShippingAmountYuan: fen2yuanAddZeroes(item.refundShippingAmount),
        }))
        if (this.searchParams.pageNo === totalPage) {
          this.finished = true
        }
        VueScrollTo.scrollTo('.el-header', 150, scrollOptions);
      } catch (e) {
        this.refundList = []
        this.error = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.refund-list {
  ::v-deep .el-input-group__prepend {
    background-color: #fff;
    width: 80px;
  }
  ::v-deep .el-tabs__item.is-top {
    color: #595959;
  }
  ::v-deep .el-tabs__item.is-active {
    color: #2386EB;
    font-weight: 500;
  }
  .el-tabs {
    margin-top: 24px;
  }
  ::v-deep .el-input__inner {
    border-radius: 0;
    color: #595959;
  }
  ::v-deep .el-input-group__prepend {
    border-radius: 0;
  }

  .fr {
    float: right;
  }

  .filter_search {
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    // overflow: hidden;
    padding-top: 1px;
  }
  .filter-input {
    width: 216px;
    margin-right: 8px;
  }
  .m_r {
    width: 324px;
    margin-right: 8px;
  }
  .search__btn {
    background: #1e8dff;
    color: #fff;
    cursor: pointer;
    width: 56px;
    height: 28px;
    display: inline-block;
    border-radius: 0;
    font-size: 12px;
    font-weight: 400;
    line-height: 28px;
  }

  .refund-title {
    display: flex;
    height: 44px;
    background: #fafafa;
    line-height: 44px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    margin-bottom: 8px;
    color: #333333;
    div {
      text-align: center;
    }
    .title-goods-detail {
      width: 487px;
    }
    .title-apply-refund-count {
      width: 188px;
    }
    .title-apply-refund-reason {
      width: 133px;
    }
    .title-apply-refund-way {
      width: 121px;
    }
    .title-apply-refund-status {
      width: 128px;
    }
    .title-apply-refund-op {
      width: 128px;
    }
  }
  .list-empty {
    text-align: center;
    margin-bottom: 24px;
    img {
      margin-top: 80px;
      width: 220px;
      height: 220px;
    }
    span {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #8c8c8c;
      line-height: 14px;
      margin-top: 8px;
      display: block;
    }
  }
  .pagination {
    margin-top: 20px;
    text-align: right;
  }
  .page-table {
    margin-bottom: 24px;
  }
}
</style>